import { render, staticRenderFns } from "./masteries.list.vue?vue&type=template&id=bd4d7b22&scoped=true&"
import script from "./masteries.list.vue?vue&type=script&lang=js&"
export * from "./masteries.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d7b22",
  null
  
)

export default component.exports